// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1ju4y","filesListContainer":"PosDisputesFiles_filesListContainer__arzdQ","filesButton":"PosDisputesFiles_filesButton__3DWDV"};